(() => {
  const init = (root) => {
    if (!root || root.dataset.rslCorePlannerBound) return;
    const form = root.querySelector('[data-rsl-choice-form]');
    const results = root.querySelector('[data-rsl-choice-results]');
    if (!form) return;

    const fieldsets = Array.from(form.querySelectorAll(':scope > fieldset'));
    if (fieldsets.length < 6) return;
    const groups = [[fieldsets[0]], [fieldsets[1], fieldsets[2]], [fieldsets[3], fieldsets[4]], [fieldsets[5]], []];
    const titles = ['Je evenement', 'Omvang en locatie', 'Wat heb je nodig?', 'Service en hulp', 'Controleer je keuzes'];
    let copy = {};
    try { copy = JSON.parse(root.querySelector('[data-rsl-choice-copy]')?.textContent || '{}'); } catch (_) {}
    const intros = [
      ['Waar kunnen we je mee helpen?', 'Kies het type evenement dat het beste aansluit. Je kunt alles later nog aanpassen.'],
      ['Hoe groot wordt het?', copy.size_intro || ''],
      ['Welke techniek wil je gebruiken?', copy.material_intro || ''],
      ['Hoe wil je het regelen?', 'Zelf ophalen, laten bezorgen of de volledige techniek door RSL laten verzorgen.'],
      ['Controleer je uitgangspunten', copy.review_intro || ''],
    ];
    groups.forEach((group, index) => group.forEach((fieldset) => { fieldset.dataset.rslCoreStep = String(index); }));

    const progressLabel = form.querySelector('[data-rsl-core-progress-label]');
    const progressTitle = form.querySelector('[data-rsl-core-progress-title]');
    const progressBar = form.querySelector('[data-rsl-core-progress-bar]');
    const stepLinks = Array.from(form.querySelectorAll('[data-rsl-core-step-link]'));
    const intro = form.querySelector('[data-rsl-core-step-intro]');
    const review = form.querySelector('[data-rsl-core-review]');
    const reviewGrid = form.querySelector('[data-rsl-core-review-grid]');
    const error = form.querySelector('[data-rsl-core-step-error]');
    const back = form.querySelector('[data-rsl-core-back]');
    const next = form.querySelector('[data-rsl-core-next]');
    const submit = form.querySelector('[data-rsl-core-submit]');
    let current = 0;
    let furthest = 0;

    const checkedText = (name) => {
      const input = form.querySelector(`input[name="${name}"]:checked`);
      return input?.nextElementSibling?.textContent?.trim() || 'Nog niet gekozen';
    };
    const checkedTexts = (name) => Array.from(form.querySelectorAll(`input[name="${name}"]:checked`))
      .map((input) => input.nextElementSibling?.childNodes?.[0]?.textContent?.trim() || input.nextElementSibling?.textContent?.trim())
      .filter(Boolean);

    const updateReview = () => {
      if (!reviewGrid) return;
      const needs = checkedTexts('behoefte');
      const location = form.querySelector('input[name="locatie"]')?.value?.trim();
      const start = form.querySelector('input[name="start"]')?.value;
      const end = form.querySelector('input[name="end"]')?.value;
      const items = [
        ['Evenement', checkedText('event'), 0],
        ['Bezoekers', checkedText('bezoekers'), 1],
        ['Omgeving', checkedText('omgeving'), 1],
        ['Techniek', needs.length ? needs.join(', ') : 'Nog niet gekozen', 2],
        ['Service', checkedText('service'), 3],
        ['Pakketniveau', checkedText('pakketniveau'), 3],
        ['Periode', start ? `${start}${end ? ` t/m ${end}` : ''}` : 'Nog niet gekozen', 3],
        ['Locatie', location || 'Nog niet ingevuld', 3],
      ];
      reviewGrid.replaceChildren(...items.map(([label, value, step]) => {
        const item = document.createElement('button');
        item.type = 'button';
        item.dataset.rslCoreReviewEdit = String(step);
        const small = document.createElement('span');
        small.textContent = label;
        const strong = document.createElement('strong');
        strong.textContent = value;
        const edit = document.createElement('b');
        edit.textContent = 'Wijzig';
        item.append(small, strong, edit);
        return item;
      }));
    };

    const validateStep = () => {
      error.hidden = true;
      error.textContent = '';
      if (current === 2 && !form.querySelector('input[name="behoefte"]:checked')) {
        error.textContent = 'Kies minimaal één onderdeel, bijvoorbeeld geluid of licht.';
        error.hidden = false;
        form.querySelector('input[name="behoefte"]')?.focus();
        return false;
      }
      return true;
    };

    const render = (focus = false) => {
      root.dataset.rslCoreCurrentStep = String(current);
      form.querySelectorAll('[data-rsl-core-step]').forEach((fieldset) => {
        fieldset.toggleAttribute('data-rsl-core-active', Number(fieldset.dataset.rslCoreStep) === current);
      });
      if (review) review.hidden = current !== 4;
      if (current === 4) updateReview();
      progressLabel.textContent = `Stap ${current + 1} van 5`;
      progressTitle.textContent = titles[current];
      progressBar.style.width = `${((current + 1) / 5) * 100}%`;
      const heading = document.createElement('strong');
      heading.setAttribute('role', 'heading');
      heading.setAttribute('aria-level', '2');
      heading.tabIndex = -1;
      heading.textContent = intros[current][0];
      const description = document.createElement('span');
      description.textContent = intros[current][1];
      intro.replaceChildren(heading, description);
      stepLinks.forEach((link, index) => {
        if (index === current) link.setAttribute('aria-current', 'step');
        else link.removeAttribute('aria-current');
        link.disabled = index > furthest;
        link.closest('li')?.classList.toggle('is-complete', index < current || index < furthest);
      });
      back.hidden = current === 0;
      next.hidden = current === 4;
      submit.hidden = current !== 4;
      error.hidden = true;
      if (focus) {
        form.querySelector('[data-rsl-core-step-intro]')?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        intro.querySelector('[role="heading"]')?.focus({ preventScroll: true });
      }
    };

    const go = (step, validate = false) => {
      if (validate && !validateStep()) return;
      current = Math.max(0, Math.min(4, step));
      furthest = Math.max(furthest, current);
      render(true);
    };
    next.addEventListener('click', () => go(current + 1, true));
    back.addEventListener('click', () => go(current - 1));
    stepLinks.forEach((link) => link.addEventListener('click', () => go(Number(link.dataset.rslCoreStepLink))));
    reviewGrid?.addEventListener('click', (event) => {
      const edit = event.target.closest('[data-rsl-core-review-edit]');
      if (edit) go(Number(edit.dataset.rslCoreReviewEdit));
    });
    form.addEventListener('input', () => { if (current === 4) updateReview(); });
    form.addEventListener('change', () => { if (current === 4) updateReview(); });
    root.querySelector('[data-rsl-choice-reset]')?.addEventListener('click', () => {
      results.hidden = true;
      go(0);
    });

    root.dataset.rslCorePlannerBound = 'true';
    form.classList.add('rsl-core-planner-ready');
    render();
  };

  const initAll = () => document.querySelectorAll('[data-rsl-core-planner]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
